import $ from "jquery";
$(document).ready(function(){
    // Check if there is a component on the page first && and that the body DOES have a class of edit-mode (sitecore added)
    if ((document.getElementsByClassName('c-tabs').length) && (document.querySelector("body").classList.contains("edit-mode"))) {
        // When in edit-mode (Content Editors) the tabs will be disabled so that all of the placeholder regions are viewable by the Content Editor.
        $('.c-tabs .tabs-panel').css('display','block').css('margin-bottom','2rem');
    }


    // https://jsfiddle.net/czf9kjfd/
    $.fn.RegisterTabBar = function (id) {
        var $ele = $(this);
        if ($ele.prop("tagName") && $ele.prop("tagName").toLowerCase() == "ul" && id != undefined) {
            $ele.attr("data-style-id", id);
            $("<style type='text/css'></style>").attr("id", id).appendTo($("body"));
            $ele.find("li").on("click", function () {
                var $li = $(this),
                    CurrentIndex = $ele.find(".active").removeClass("active").index(),
                    ClickedIndex = $li.addClass("active").index();

                function SetStyle($ele, $li, IsToLeft) {

                    var ID = $ele.attr("data-style-id");
                    if (ID == undefined) return;
                    if ($ele.width() <= 0) {
                        setTimeout(function () { SetStyle($ele, $li, IsToLeft); }, 100);
                        return;
                    }

                    let gapToMove = "";
                    if ($li.is(':first-child')) {
                        gapToMove = "0rem";
                    } else if ($li.is(':last-child')) {
                        if (Foundation.MediaQuery.current === 'small') {
                            gapToMove = "0.5rem";
                        } else {
                            gapToMove = "1.5rem";
                        }
                    } else {
                        if (Foundation.MediaQuery.current === 'small') {
                            gapToMove = "0.5rem";
                        } else {
                            gapToMove = "1.5rem";
                        }
                    }

                    $("style#" + ID).text(
                        ".c-tabs ul[data-style-id='" + ID + "']:before { " +
                        "left: calc(" + $li.position().left + "px + " + gapToMove + "); " +
                        "right: calc(" + ($ele.width() - $li.position().left - $li.outerWidth()) + "px - " + gapToMove + "); " +
                        "-webkit-transition: left " + (IsToLeft ? ".15s" : ".35s") + ", right " + (IsToLeft ? ".15s" : ".35s") + "; " +
                        "transition: left " + (IsToLeft ? ".15s" : ".35s") + ", right " + (IsToLeft ? ".15s" : ".35s") + "; " +
                        "} "
                    );
                }
                SetStyle($ele, $li, ClickedIndex < CurrentIndex);
            });
        }
        return $ele;
    }

    $(".c-tabs ul.c-tabs__options").each(function(i, obj) {
        $(this).RegisterTabBar("slider"+i+"");
        setTimeout(function(){
			if ($(".c-tabs ul.c-tabs__options[data-style-id='slider"+i+"']").find("li.active").length > 0 ) {
				$(".c-tabs ul.c-tabs__options[data-style-id='slider"+i+"']").find("li.active").click();
				// let dest = document.querySelector('.c-tabs__options li.active a');
				// let destString = dest.getAttribute('href');
				// let firstChar = destString.charAt(0);
				// if (destString.charAt(0) == "#") {
				// 	// let newLocation = location.href.replace(location.hash,destString); 
				// 	location.hash = destString;
				// }
			} else {
				$(".c-tabs ul.c-tabs__options[data-style-id='slider"+i+"']").find("li:first-child").click();
			}
        }, 200);
        $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
            $(this).RegisterTabBar("slider"+i+"");
            setTimeout(function(){
				if ($(".c-tabs ul.c-tabs__options[data-style-id='slider"+i+"']").find("li.active").length > 0 ) {
					$(".c-tabs ul.c-tabs__options[data-style-id='slider"+i+"']").find("li.active").click();
					// let dest = document.querySelector('.c-tabs__options li.active a');
					// let destString = dest.getAttribute('href');
					// let firstChar = destString.charAt(0);
					// if (destString.charAt(0) == "#") {
					// 	// let newLocation = location.href.replace(location.hash,destString); 
					// 	location.hash = destString;
					// }
				} else {
				 $(".c-tabs ul.c-tabs__options[data-style-id='slider"+i+"']").find("li:first-child").click();
				 alert('First child');
				}
            }, 200);
        });
    });
});




